import { render, staticRenderFns } from "./IMListBOD.vue?vue&type=template&id=6aa43d52&scoped=true&lang=pug"
import script from "./IMListBOD.vue?vue&type=script&lang=js"
export * from "./IMListBOD.vue?vue&type=script&lang=js"
import style0 from "./IMListBOD.vue?vue&type=style&index=0&id=6aa43d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa43d52",
  null
  
)

export default component.exports